import { environment } from '../../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('AddonService', AddonService);

  AddonService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'TranslationModalService',
    'AddonModalService',
    'WindowModalService',
  ];

  function AddonService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    TranslationModalService,
    AddonModalService,
    WindowModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'addons';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getAddons: getAddons,
      getAddon: getAddon,
      saveAddon: saveAddon,
      openAddonTranslations: openAddonTranslations,
      deleteAddon: deleteAddon,
      changeAddonStatus: changeAddonStatus,
      updateAddons: updateAddons,
      openAddonModal: openAddonModal,
      openAddonsModal: openAddonsModal,
      setAddonsSelected: setAddonsSelected,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filterCriteria;
    }

    function getAddons(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getAddon(id, language) {
      var params = { lang: null };

      if (language) {
        params.lang = language;
      }

      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        params,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveAddon(item, language) {
      var itemAddedMsg = $translate('NEW_ADDED_ADDON');
      var itemAddedFlashMsg =
        $translate('ADDON_ADDED_MSG') + ' ' + $translate('REMEMBER_ADD_TRANSLATIONS');
      var itemModifiedMsg = $translate('MODIFIED_ADDON');

      var method = item.id ? 'put' : 'post';
      var url = item.id ? apiUrl + '/' + item.id : apiUrl;

      var lang = language ? language : config.DEFAULT_CONTENT_LANGUAGE;

      function success(response) {
        var msg = item.id ? itemModifiedMsg : itemAddedMsg;
        utils._successMsg(msg);

        if (!item.id) {
          // Create
          utils._setFlashMessage(itemAddedFlashMsg);
        }

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(method, url, { addon: item, lang: lang }, success, failure);
    }

    function openAddonTranslations(item, additionalLanguages) {
      var template = './app/ajs/admin/addons/modals/addon-detail-translation.html';

      var modalParams = {
        title: item.name,
        item: item,
        additionalLanguages: additionalLanguages,
      };

      var initializeCallback = function (itemId, language) {
        return getAddon(itemId, language).then(function (data) {
          return data;
        });
      };

      var confirmCallback = function (item, language) {
        return saveAddon(item, language).then(function (data) {
          if (!data.status) {
            return data.response;
          }

          return false;
        });
      };

      TranslationModalService.open(template, modalParams, initializeCallback, confirmCallback);
    }

    function deleteAddon(item, successCallback) {
      var params = {
        title: 'DELETE_ADDON',
        itemName: item.name,
        reason: 'DELETE_ITEM_REASON',
        confirmButtonLabel: 'DELETE_ADDON',
        successMsg: 'DELETED_ADDON',
      };

      var url = apiUrl + '/' + item.id;
      utils.deleteItem(url, successCallback, params);
    }

    function changeAddonStatus(item) {
      utils.changeItemStatus(apiUrl + '/' + item.id, item);
    }

    function updateAddons(action, items, successCallback) {
      utils.updateItems(apiUrl, action, items, successCallback);
    }

    function openAddonModal(item, additionalLanguages, mode, features, getItemsCallback) {
      var templateUrl = './app/ajs/admin/addons/modals/addon-detail-modal.html';

      var originalItem = angular.copy(item);

      var modalParams = {
        title: 'ADDON_DETAILS',
        item: originalItem,
        additionalLanguages: additionalLanguages,
        mode: mode,
        parentOptions: features,
      };

      var confirmCallback = function (selectedItem) {
        if (item.id) {
          // Edit
          item.name = selectedItem.name;
          item.description = selectedItem.description;
          item.total_units = selectedItem.total_units;
          item.unit_price = selectedItem.unit_price;

          item.feature_id = selectedItem.feature_id;
          item.feature.name = selectedItem.feature.name;

          return utils.itemListChanged(selectedItem.id);
        }

        return getItemsCallback(selectedItem);
      };

      WindowModalService.open(templateUrl, modalParams, confirmCallback);
    }

    function openAddonsModal(getItemsCallback) {
      AddonModalService.openAddons(getItemsCallback);
    }

    function setAddonsSelected(addons, field) {
      var addonsSelected = [];
      addons.forEach(function (addon) {
        var item = {
          total_units: addon.total_units,
          unit_price: addon.unit_price,
          status: addon.status,
          id: null,
        };

        if (!addon.new) {
          // update
          item.id = addon.id; // plan_addon id
        }

        item[field] = addon[field];

        addonsSelected.push(item);
      });

      return addonsSelected;
    }
  }
})();
